import React from "react";

const TipBox = (props: { children: React.ReactNode[] | React.ReactNode }) => (
  <div className="bg-blue-50 rounded p-6 my-4">{props.children}</div>
);

export default TipBox;
